export enum ComponentId {
  INCIDENT_STATEMENTS_POLICE_PRESENT = "police",
  INCIDENT_STATEMENTS_POLICE_DEPARTMENT = "policeDepartment",
  INCIDENT_STATEMENTS_CASE_NUMBER = "caseNumber",
  INCIDENT_STATEMENTS_POLICE_IMAGES = "police",
  INCIDENT_STATEMENTS_PERPETRATOR_STATEMENT = "perpetratorStatement",
  INCIDENT_STATEMENTS_PERPETRATOR_IMAGES = "perpetrator",
}
